/**
 * CardInfoIcon – SVG icon.
 */
import IArrow from '@shared/types/props/arrow';
import Screen from '@screen';

/** Info / arrow icon for cards. */
export default function CardInfoIcon({
  focused,
  ratio = 1,
  height = 19,
  width = 19,
}: IArrow) {
  return (
    <svg
      width={`${width * ratio * Screen.widthRatio}`}
      height={`${height * ratio * Screen.widthRatio}`}
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.33333 2C5.28325 2 2 5.28325 2 9.33333C2 13.3834 5.28325 16.6667 9.33333 16.6667C13.3834 16.6667 16.6667 13.3834 16.6667 9.33333C16.6667 5.28325 13.3834 2 9.33333 2ZM0 9.33333C0 4.17868 4.17868 0 9.33333 0C14.488 0 18.6667 4.17868 18.6667 9.33333C18.6667 14.488 14.488 18.6667 9.33333 18.6667C4.17868 18.6667 0 14.488 0 9.33333Z'
        fill={focused ? 'black' : 'white'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.33203 8.33325C9.88432 8.33325 10.332 8.78097 10.332 9.33325V12.6666C10.332 13.2189 9.88432 13.6666 9.33203 13.6666C8.77975 13.6666 8.33203 13.2189 8.33203 12.6666V9.33325C8.33203 8.78097 8.77975 8.33325 9.33203 8.33325Z'
        fill={focused ? 'black' : 'white'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.33203 6C8.33203 5.44772 8.77975 5 9.33203 5H9.34036C9.89265 5 10.3404 5.44772 10.3404 6C10.3404 6.55228 9.89265 7 9.34036 7H9.33203C8.77975 7 8.33203 6.55228 8.33203 6Z'
        fill={focused ? 'black' : 'white'}
      />
    </svg>
  );
}
